import Api from './api';

const historyListRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/history', {
        headers: { Authorization: 'Bearer ' + access_token } ,
        params: query
    })
}

export default { historyListRequest }



// WEBPACK FOOTER //
// ./src/api/apiHistory.js